<template>
  <div class="foot">
    <div class="jumpBox">
      <a href="/Inicio">Inicio</a>
      <a href="/Sobre">Sobre nosotros</a>
      <a href="/Ayuda">Ayuda</a>
    </div>
    <div class="jumpBox">
      <a href="/Aviso">Política de privacidad</a>
      <a href="/Uso">Términos y condiciones de uso</a>
    </div>

    <div>
      <div
        style="font-size: 20px;
                 font-family: ArialMT;
                 font-weight: 400;
                 color: #FFFFFF;
                 text-decoration: none;
                 margin-bottom: 41px;
                "
      >
        Síguenos en:
        <a href="https://www.facebook.com/muchamo.com" target="_blank">
          <img
            style="vertical-align: middle;margin: 0 20px;"
            src="../assets/image/facebookIcon.png"
            alt=""
          />
        </a>
        <a href="https://www.instagram.com/muchamo.com" target="_blank">
          <img
            style="vertical-align: middle; width:35px;"
            src="../assets/image/insIcon.png"
            alt=""
          />
        </a>
      </div>
      <!-- href="https://prod-peru.obs.na-mexico-1.myhuaweicloud.com/Muchamo_v1.0.9.apk" -->
      <!-- href="https://www.muchamo.com/Muchamo_google_release_v1.0.10_2403191759.apk" -->
      <a href="">
        <img src="../assets/image/descarga.png" alt="" />
      </a>
    </div>

    <ul>
      <!-- <a href="/Inicio"><li>Inicio</li></a>
      <a href="/Sobre"><li>Sobre nosotros</li></a>
      <a href="/Ayuda"><li>Ayuda</li></a> -->
      <!-- <a
        href="https://prod-peru.obs.na-mexico-1.myhuaweicloud.com/Muchamo_v1.0.9.apk"
      >
        <li>Descarga la app</li>
      </a> -->
      <!-- <a href="/Aviso"><li>Política de privacidad</li></a>
      <a href="/Uso"><li>Términos y condiciones de uso</li></a> -->
    </ul>
  </div>
</template>

<script>
export default {
  name: "footPage",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.foot {
  width: 100%;
  background: #1e1f30;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 44px 0 20px;
  ul {
    display: flex;
    li {
      list-style: none;
      color: #fff;
      margin-right: 45px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
    }
  }
  .jumpBox {
    margin-right: 233px;
    a {
      display: block;
      font-size: 20px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 20px;
    }
  }
}
</style>
